import actionsGetters from './getterTypes'

const getters = {
  [actionsGetters.GET_USERS]: state => state.users,
  [actionsGetters.GET_ROLES]: state => state.roles,
  [actionsGetters.GET_ERRORS]: state => state.loginDebug,
  [actionsGetters.GET_PAGINATION]: state => state.pagination
}

export default {
  ...getters
}
